// @ts-nocheck

// ── Sticky add-to-cart balk (mobiel) ──
(function () {
  if (window.innerWidth > 768) return;

  var bar = document.createElement('div');
  bar.className = 'sly-sticky-atc';
  bar.innerHTML =
    '<div class="sly-sticky-atc-info">' +
      '<div class="sly-sticky-atc-title"></div>' +
      '<div class="sly-sticky-atc-price"></div>' +
    '</div>' +
    '<button type="button" class="sly-sticky-atc-btn">Aan winkelwagen</button>';
  document.body.appendChild(bar);

  function findBtn() {
    return document.querySelector('product-form button[type="submit"]') ||
           document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
           document.querySelector('button[name="add"]');
  }

  function fillInfo() {
    var title = document.querySelector('h1');
    var priceEl = document.querySelector('.price-item--sale, .price-item--regular, .price-item');
    if (title) bar.querySelector('.sly-sticky-atc-title').textContent = title.textContent.trim();
    if (priceEl) bar.querySelector('.sly-sticky-atc-price').textContent = priceEl.textContent.trim();
  }

  bar.querySelector('.sly-sticky-atc-btn').addEventListener('click', function () {
    var btn = findBtn();
    if (btn) btn.click();
  });

  document.addEventListener('variant:changed', function () {
    var p = document.querySelector('.price-item--sale, .price-item--regular, .price-item');
    if (p) bar.querySelector('.sly-sticky-atc-price').textContent = p.textContent.trim();
  });

  function setupObserver() {
    var mainBtn = findBtn();
    if (!mainBtn) return false;
    fillInfo();
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(mainBtn);
    return true;
  }

  // Probeer meteen, dan met vertraging als Horizon nog aan het laden is
  if (!setupObserver()) {
    setTimeout(function () {
      if (!setupObserver()) {
        setTimeout(setupObserver, 1000);
      }
    }, 500);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  var m2El = document.querySelector('[data-m2-per-plaat]');
  if (!m2El) return;
  var m2 = m2El.getAttribute('data-m2-per-plaat') || '1.44';
  var form = document.querySelector('product-form form, form[action*="/cart/add"]');
  if (!form) return;
  var hidden = document.createElement('input');
  hidden.type = 'hidden';
  hidden.name = 'properties[_m2_per_plaat]';
  hidden.value = m2;
  form.appendChild(hidden);
});

function slyToggle(btn) {
  var content = btn.nextElementSibling;
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!isOpen));
  content.classList.toggle('open', !isOpen);
}

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Enter') return;
  var modal = document.getElementById('stonely-calc-modal');
  if (modal && modal.style.display === 'flex') stonelyBereken();
});

function stonelyBereken() {
  var b = parseFloat(document.getElementById('calc-breedte').value);
  var h = parseFloat(document.getElementById('calc-hoogte').value);
  var el = document.querySelector('[data-m2-per-plaat]');
  var plaat_m2 = el ? parseFloat(el.getAttribute('data-m2-per-plaat')) : 1.44;
  if (!b || !h || b <= 0 || h <= 0) return;
  var wandM2 = (b * h) / 10000;
  var platenExact = Math.ceil(wandM2 / plaat_m2);
  var platenIncl  = Math.ceil((wandM2 * 1.10) / plaat_m2);
  document.getElementById('calc-resultaat').style.display = 'grid';
  document.getElementById('calc-m2').innerHTML =
    '<span style="font-size:1.8rem;font-weight:300;display:block;color:#2C2C2A;font-family:\'Cormorant Garamond\',serif">' + wandM2.toFixed(2) + '</span>' +
    '<span style="font-size:0.65rem;color:#9E9B94;text-transform:uppercase;letter-spacing:0.15em;font-family:\'Jost\',sans-serif">m²</span>';
  document.getElementById('calc-exact').innerHTML =
    '<span style="font-size:1.8rem;font-weight:300;display:block;color:#2C2C2A;font-family:\'Cormorant Garamond\',serif">' + platenExact + '</span>' +
    '<span style="font-size:0.65rem;color:#9E9B94;text-transform:uppercase;letter-spacing:0.15em;font-family:\'Jost\',sans-serif">exact</span>';
  document.getElementById('calc-incl').innerHTML =
    '<span style="font-size:1.8rem;font-weight:300;display:block;color:#ffffff;font-family:\'Cormorant Garamond\',serif">' + platenIncl + '</span>' +
    '<span style="font-size:0.65rem;color:#ffffff;text-transform:uppercase;letter-spacing:0.15em;font-family:\'Jost\',sans-serif">+10% verlies</span>';
  var input = document.querySelector('input[name="quantity"]');
  if (input) {
    input.value = platenIncl;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
